import React from 'react';
export const Nav01DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://www.bmr-oe.com/static/images/logo15.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item~mf2enloxx3',
        className: 'header0-item',
        children: {
          href: '/#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>首页</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>产品中心</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m9mfhrvs9sh-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/强激光78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8wyzpxxeu-editor_css',
                  children: (
                    <span>
                      <span>
                        <p>强激光双轴快反镜</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second1',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/通用双轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <p>通用双轴快反镜</p>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second2',
            },
          },
          {
            name: 'sub~m8x12rhcd3r',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/单轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>单轴快反镜</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second3',
            },
          },
          {
            name: 'sub~m8x12unqvh',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/摆扫镜30.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>摆扫镜</p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second4',
            },
          },
          {
            name: 'sub~m8x12vr6qz',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/振镜6240.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <p>加固振镜</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second5',
            },
          },
          {
            name: 'sub~m8x12wndado',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电调镜78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>电调镜</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second6',
            },
          },
          {
            name: 'sub~m8x12xgznka',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电动镜127.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>电动镜</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second7',
            },
          },
          {
            name: 'sub~m8x12yp8s7o',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/激光通信20.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <p>激光通信快反镜</p>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second8',
            },
          },
          {
            name: 'sub~m9mfjmjr4va',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/永磁同步75.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <p>无槽永磁同步电机</p>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second9',
            },
          },
        ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/#/fourth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>现货商城</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/#/tenth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>应用领域</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/#/fifth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>新闻动态</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~m98pdg3g8rs',
        className: 'header0-item',
        children: {
          href: '/#/sixth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>联系我们</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner10DataSource = {
  wrapper: { className: 'banner1 m8wmyqt62ma-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 m8wmxqt4hsf-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m8wt5yzvohu-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <blockquote>
                                铂米瑞光电，快反镜行业领跑者
                              </blockquote>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m8wtjvr1hjk-editor_css',
          children: (
            <span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 m96u0zciy-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m96ve128cj-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>专注光电领域二十余年</p>
                          <p>匠心出精品</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m96u6oixptm-editor_css',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
      },
    ],
    autoPlay: true,
    type: ['across'],
    autoPlaySpeed: 5000,
  },
};
export const Content131DataSource = {
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m999dm48xhu-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <p>BMR7530-25</p>
                                      <p>摆扫镜</p>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/bg/摆扫镜25.png',
        className: 'title-image mf29ez6ep5k-editor_css',
      },
      {
        name: 'content2',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>
                            像移补偿：专门为制冷红外周视系统而设计，反向扫描补偿像方位移。
                          </p>
                          <p>
                            整体高度低：传感器在反射镜的背后，有效降低高度，易于结构布置。
                          </p>
                          <p>
                            刚性连接：镜座和电机轴之间采用刚性连接，无螺栓拧紧，可靠性高。
                          </p>
                          <p>
                            小型驱动板：配合高密度、小体积的数字化驱动板，重量轻、易布局。
                          </p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99a2icryqg-editor_css',
      },
    ],
  },
};
export const Pricing20DataSource = {
  wrapper: {
    className: 'home-page-wrapper pricing2-wrapper m99abc95oi-editor_css',
  },
  page: { className: 'home-page pricing2 m99aa4fupkr-editor_css' },
  OverPack: {
    playScale: 0.3,
    className: 'pricing2-content-wrapper m99a9po213-editor_css',
  },
  titleWrapper: {
    className: 'pricing2-title-wrapper m99bw5368cl-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>参数表</p>
          </span>
        ),
        className: 'pricing2-title-h1 m99a49tp7i8-editor_css',
      },
    ],
  },
  Table: {
    name: 'tabsTitle',
    size: 'default',
    className:
      'pricing2-table m99a63ja4aq-editor_css m99a8j73b49-editor_css m99bf1xg1nh-editor_css',
    columns: {
      children: [
        {
          dataIndex: 'free',
          key: 'free',
          name: 'free',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>序号</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'basic',
          key: 'basic',
          name: 'basic',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>类别</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'pro',
          key: 'pro',
          name: 'pro',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>项目</p>
                        </span>
                      </span>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'unlimited',
          key: 'unlimited',
          name: 'unlimited',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>参数</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
      ],
    },
    dataSource: {
      children: [
        {
          name: 'list0',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>1</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bjttojeb-editor_css',
            },
            {
              children: (
                <span>
                  <p>反射镜</p>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content m99bjqn06s-editor_css',
            },
            {
              children: (
                <span>
                  <p>镜片尺寸</p>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99bjmk6316-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>Ф25×2.0mm</p>
                  </span>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99bjwmf1s8-editor_css',
            },
          ],
        },
        {
          name: 'list1',
          children: [
            {
              children: (
                <span>
                  <p>2</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkb1z7ws-editor_css',
            },
            {
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content',
            },
            {
              children: (
                <span>
                  <p>镜片材质</p>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99biypx1og-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>碳化硅</p>
                  </span>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99afqi6x9a-editor_css',
            },
          ],
        },
        {
          name: 'list2',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>3</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkejdaur-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>反射率</p>
                </span>
              ),
              className: 'pricing2-table-content m99bltgunb-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ≥98%</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bjkp5yz-editor_css',
            },
          ],
        },
        {
          name: 'list3',
          children: [
            {
              children: (
                <span>
                  <p>4</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkhm8b3b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <p>
                    传感器<br />
                  </p>
                </span>
              ),
              className: 'pricing2-table-content m99bl6p9nf-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>传感形式</p>
                </span>
              ),
              className: 'pricing2-table-content m99bm54unvo-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p>光电式</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99borf50f7-editor_css',
            },
          ],
        },
        {
          name: 'list4',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>5</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkkv0vl-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>分辨率</p>
                </span>
              ),
              className: 'pricing2-table-content m99bmakhv9g-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p>≤4.0urad</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99botxcyi-editor_css',
            },
          ],
        },
        {
          name: 'list5',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>6</p>
                </span>
              ),
              className: 'pricing2-table-content m99bknwfipn-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <p>
                      控制器<br />
                    </p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bnta347-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>摆角范围</p>
                </span>
              ),
              className: 'pricing2-table-content m99bmcmbc3p-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ±7.5︒</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmhzwzwu-editor_css',
            },
          ],
        },
        {
          name: 'list~m9992qcqan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>7</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkqpz8xs-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>闭环带宽</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmflz1ur-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> ≥600Hz</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bp1b7c4n-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995d9gi2j',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>8</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkw8os8b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>信号阶跃</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmikkli-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> ≤1.5ms</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bpp70n5f-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995e20r0n',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>9</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkwrio7-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        驱动器<br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl7ryoos-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>电源电压</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl9cj9-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ±15V或+28V</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bsnq4szi-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995ewkw1m',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>10</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkyuktdf-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <span>
                      <p> 峰值电流</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmokz5m7-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ≤3A</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bq7klifu-editor_css',
            },
          ],
        },
      ],
    },
  },
};
export const Content130DataSource = {
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m994rqea0y-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper m99d35o3ufq-editor_css',
    children: [
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/size/摆镜25.png',
        className: 'title-image m99d1c63x6g-editor_css',
      },
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>电机尺寸图</p>
            </span>
          </span>
        ),
        className: 'title-h1 m994tqtqy6-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <span>
              <span>
                <p>单位：mm</p>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99cy2eu9e9-editor_css',
      },
    ],
  },
};
export const Content132DataSource = {
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m99ctseby8q-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper m99d7t921cf-editor_css',
    children: [
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/size/数字光电驱动板.png',
        className: 'title-image mf29fym26de-editor_css',
      },
      {
        name: 'title',
        children: (
          <span>
            <p>驱动板尺寸图</p>
          </span>
        ),
        className: 'title-h1 mfd47q27rs-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <p>单位：mm</p>
          </span>
        ),
        className: 'title-content m99czfafr5e-editor_css',
      },
    ],
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://www.bmr-oe.com/static/images/logo15.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>快反镜行业领跑者</p>
                </span>
              ),
              className: 'm8frbj7scy-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: { children: '产品' },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '/产品手册-V1.1.pdf',
              children: (
                <span>
                  <span>
                    <p>选型手册</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '/接口定义-V1.0.pdf',
              children: (
                <span>
                  <span>
                    <span>
                      <p>接口定义</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>资源</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/eighth',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>常见问题</p>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/ninth',
              name: 'link1',
              children: (
                <span>
                  <p>在线工具</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>关于</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/seventh',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <span>
                      <p>公司简介</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/sixth',
              name: 'link1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>联系我们</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>?2025 by 上海铂米瑞&nbsp;All Rights Reserved &nbsp; 沪ICP备2025124982号</span>
      </span>
    ),
  },
};
